module.exports = __webpack_public_path__ + "img/2.4afb16db.png";